// container which shows billing informational boxes for a group.
// current amount
// next payment date
// payment info
// currently this is dummy data. Idea is to provide ui concepts.
export class CurrentBillingInfoBoxes extends HTMLElement {

  constructor() {
    super();
  }

  async connectedCallback() {
    const fakeDate = Math.floor(new Date().getTime() / 1000)
    this.groupId = this.getAttribute("group_id");

    this.innerHTML = `
      <style>
        .light-colored-container {
          border: 1px solid #ccc;
          background-color: #F6F8FA;
          border-radius:4px;
          padding:10px;
          min-height:100px;
        }

        .light-colored-container ul {
          list-style:none !important;
          padding:unset;
        }

        .light-colored-container h4 {
          margin-bottom:12px;
        }
        
        .light-colored-container h4,
        .light-colored-container h4 a {
          color: #57606a;
        }

        .light-colored-container h3 {
          font-size:20px;
        }
      </style>

      <div class="row">
        <div class="col-md-4 no-gutters">
          <current-bill-amount
            bill_amount=51534
          />
        </div>

        <div class="col-md-4">
          <next-due-date
            groupId=${this.groupId}
            date=${fakeDate}
          />
        </div>

        <div class="col-md-4 no-gutters">
          <payment-info
            groupId=${this.groupId}            
          />
        </div>
      </div>
    `
  }
}
customElements.define('current-billing-info-boxes', CurrentBillingInfoBoxes)